<template>
  <div class="p-3 bg-white">
    <shared-blacklist-add
      @addBlacklistSuccess="addBlacklistSuccess"
    ></shared-blacklist-add>

    <div class="text-center">
      <vs-button id="addBlacklistButton" class="m-2" color="primary" type="filled" @click.prevent="addBlacklist">{{ $t('save') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="cancelAddBlacklist">{{ $t('cancel') }}</vs-button>
    </div>
  </div>
</template>

<script>
import SharedBlacklistAdd from '@/views/Shared/Blacklist/Add'
import { EventBus } from '@/../eventbus'
export default {
  name: 'Window.Blacklist.Add',
  components: {
    SharedBlacklistAdd
  },
  methods: {
    addBlacklist () {
      EventBus.$emit('initAddBlacklist')
    },
    addBlacklistSuccess () {
      this.$windowOpenerHelper.notifyOpener('reload_blacklist_table')
      window.close()
    },
    cancelAddBlacklist () {
      this.$windowOpenerHelper.notifyOpener('reload_blacklist_table')
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
